import { exportToCSV } from "@fuse/utils/generateCsv";
import exportExcel  from "@fuse/utils/excel";
import generatePdf  from "@fuse/utils/generatePdf";
import generateGroupByFileData  from "@fuse/utils/groupByDataFormat";
import axios from "@fuse/utils/axios";
import { clientSideApplyFilterModel } from "helper/common";
import { getContractStatus } from "helper/status";

const tableNameForExportDataWithoutSSRM = [
  "super_admin_portal_client_list",
  "agents",
  "customer_management",
  "Archived Service Tickets",
  "asset_activity_logs",
  "manufacturer_activity_logs",
  "asset_category_activity_logs",
  "model_activity_logs",
  "accessory_acivity_logs",
  "custom_attributes_activity_logs",
  "asset_status_activity_logs",
  "accessory_category_activity_logs",
  "contract_activity_logs",
  "payment_term_activity_logs",
  "contract_status_activity_logs",
  "contract_type_activity_logs",
  "service_provider_activity_logs",
  "service_level_agreement_activity_logs",
  "service_request_activity_logs",
  "service_request_category_activity_logs",
  "service_request_status_activity_logs",
  "service_request_source_activity_logs",
  "role_activity_logs",
  "shipping_activity_logs",
  "location_type_activity_logs",
  "depadepartment_activity_logsrtment",
  "user_activity_logs",
  "Archived Asset",
  "Model",
  "Archived Contract",
  "service_provider",
  "Contract",
  "shipping",
  "user",
  "Insight log",
  "service_request",
  "manufacture_activity_logs"
];

const exportedFileName = {
  "super_admin_portal_client_list": "clients",
  "agents": "agents",
  "customer_management": "customer",
  "Archived Service Tickets": "archived_service_ticket"
}

const multiFormatFileManager = async (fileType, tableName, gridRef, moduleName) => {
  if(['asset', 'assets'].includes(tableName)) await getAssetDetails(fileType, gridRef)
  if(tableName  === 'subscription') await getSubscriptionDetails(fileType)
  if(['contract_headers', 'Contract'].includes(tableName)) await getContractDetails(fileType, gridRef?.current?.filterModelArr)
  if(['service_request', "service_request_views", 'Archived Service Tickets'].includes(tableName)) await getServiceTicketDetails(fileType, gridRef, tableName)
  if(tableName  === 'shipping') await getLocationDetails(fileType, gridRef?.current?.filterModelArr)
  if(tableName  === 'user') await getUserDetails(fileType)
    // new way to export using gridRef applicable for without SSRM
  if(tableName  === 'Archived Asset' || tableName === 'Archived Contract' || tableName === 'service_provider' || 
    tableName  === 'Manufacturer' || tableName === 'Model') await generateCSVForAllModules(fileType, gridRef, tableName)
  if(tableName  === 'user_audit_logs') await getUserAuditLogDetails(fileType, gridRef)
  if(tableName  === 'Data Report') await getStandardReportDetails(fileType, gridRef, moduleName)
  if(tableName.includes('activity_logs')) await generateCSVForAllModules(fileType, gridRef, tableName)

}

function generateFile(defaultHeader, results, fileType, filePrefix){
  const csvArr = [defaultHeader]
  for(const obj of results){
    if(filePrefix  === 'asset') csvArr.push((Object.values(obj)).slice(0, -1))
    else csvArr.push((Object.values(obj)))
  }
  if (fileType === 'Excel') exportExcel(defaultHeader,csvArr, `${filePrefix}`)
  if (fileType === 'CSV') exportToCSV(csvArr, `${filePrefix}`) 
  if (fileType === 'PDF') generatePdf(csvArr, `${filePrefix}`) 

  return true
}

function generateGroupColumnNameAndColumnValue(resultColumnArr,groupByColumnName){
  
  if(!Array.isArray(resultColumnArr)){
    groupByColumnName += `---> ${Object.keys(resultColumnArr)[0]}`
    return generateGroupColumnNameAndColumnValue(resultColumnArr[Object.keys(resultColumnArr)[0]], groupByColumnName)
    
  }
    return {groupByColumnName,resultColumnArr}
  
}

function generateFileWhichIncludeGroupByColumn(defaultHeader, results, fileType, filePrefix){
  const csvArr = [defaultHeader]
  for(const key of Object.keys(results)){
   const {groupByColumnName,resultColumnArr} = generateGroupColumnNameAndColumnValue(results[key],`--> ${key ?? ''}`)
    csvArr.push([groupByColumnName])
    
    for(const columnData of resultColumnArr){
        csvArr.push(['',...(Object.values(columnData))])
    }
    // console.log("groupByString", groupByString,obj)
    // if(!Array.isArray(results)){
    //   groupByString += `---> ${key}`
    // }else{
    //   csvArr.push([groupByString])
    //   for(let obj of results[key]){
    //     csvArr.push(['',...(Object.values(obj))])
    //   }
    // }
    
    

  }
  if (fileType === 'Excel') exportExcel(defaultHeader,csvArr, `${filePrefix}`)
  if (fileType === 'CSV') exportToCSV(csvArr, `${filePrefix}`) 
  if (fileType === 'PDF') generatePdf(csvArr, `${filePrefix}`) 

  return true
}

async function getAssetDetails(fileType, gridRef){
  const defaultHeader = ['Serial Number', 'Asset Tag', 'Asset Name', 'User', 'Status',
    'Contract Number', 'Contract Tag', 'Model Name', 'Model Number', 'Category', 'Manufacture',
    'Location', 'Address', 'Notes', 'Created Date', 'Updated Date', 'Source', 'Network Status'
  ]
  const { results } = (await axios.post(`assets/all-asset-for-csv`, {
      dataSourceParams:{
      "filterModel": Object.keys(gridRef?.current?.api?.getFilterModel())?.length ? gridRef?.current?.api?.getFilterModel() : gridRef.current?.filterModelArr,
      }
    }
  )).data.data
  generateFile(defaultHeader, results, fileType, 'asset')

}

async function getUserAuditLogDetails(fileType, gridRef){
  const defaultHeader = ['Name', 'Role', 'Login Time',
  'Logout Time', 'Total Session','Ip Address']
  const { results } = (await axios.post(`user/all-user-audit-log-for-csv`, {
    dataSourceParams:{
      "filterModel": gridRef?.current?.api?.getFilterModel(),
    }
  }
  )).data.data
  generateFile(defaultHeader, results, fileType, 'user-audit-log')
}

async function getSubscriptionDetails(fileType){
  const defaultHeader = ['Subscription Name', 'Provider Name', 'Status', 'No Of Seats',
    'Category', 'Department', 'Start Date', 'End Date', 'Amount', 'Billing Cycle',
    'Billing Cycle Date', 'Website', 'PO Date', 'PO Number', 'Card Name', "Card Holder's Name",
  ]
  const { results } = (await axios.get(`subscription/all-subscription-for-csv`)).data.data
  generateFile(defaultHeader, results, fileType, 'subscription')

}

async function generateCSVForAllModules(fileType, gridRef, tableName){
  const fileName = exportedFileName[tableName] ?? tableName

  const allRowData = gridRef.current.props.rowData
  const columnKeyNameArr = (gridRef.current.api.columnModel.columnDefs.map(item=> item?.field)).slice(1)
  const defaultHeader = (gridRef.current.api.columnModel.columnDefs.map(item=> item.headerName)).slice(1)

  const filteredArray = allRowData.map(item => {
    return columnKeyNameArr.reduce((acc, key) => {
        acc[key] = item[key] || '';
        return acc;
    }, {});
  });
  generateFile(defaultHeader, filteredArray, fileType, fileName)
}

async function getContractDetails(fileType, filterModel){
  const defaultHeader = ['Contract Number', 'Contract', 'Start Date', 'End Date',
    'Type', 'Contract Tag', 'No Of Assets', 'SLA', 'Service Provider', 'Master',
    'Parent Contract', 'New/renew', 'Location'
  ]
  const { results } = (await axios.get(`end-user-contracts/all-contract-for-csv`)).data.data
  let mapData = results
  if (filterModel) {
    const result = results?.map((item) => {
      return {
          ...item,
          contract_status: getContractStatus(item?.end_date)?.status || '',
        }
    })
    mapData = clientSideApplyFilterModel(result, filterModel)
    // defaultHeader.push('Contract Status')
  }

  generateFile(defaultHeader, mapData, fileType, 'contract')
}

async function getServiceTicketDetails(fileType, gridRef, tableName){
  const defaultHeader = ['Ticket Number', 'Serial Number', 'Status', 'Agent', 'Location', 'Problem Summery',
    'Created Date', 'Updated Date'
  ]
  const isArchived = !['service_request', 'service_request_views']?.includes(tableName)
  const { results } = (await axios.post(`service/all-service-ticket-for-csv?archived=${isArchived}`, {
    dataSourceParams:{
      "filterModel": Object.keys(gridRef?.current?.api?.getFilterModel())?.length ? gridRef?.current?.api?.getFilterModel() : gridRef.current?.filterModelArr,
    }
  })).data.data
  generateFile(defaultHeader, results, fileType, 'service_ticket')

}

async function getLocationDetails(fileType, filterModel){
  const defaultHeader = ['Location Name', 'Address 1', 'Address 2', 'City',
    'State/Province', 'Zip', 'Country', 'Note', 'Location Type Name',
    'Number Of Assets'
  ]
  const { results } = (await axios.get(`shipping/all-location-for-csv`)).data.data
  let mapData = results
  if (filterModel) {
    mapData = clientSideApplyFilterModel(results, filterModel)
  }

  generateFile(defaultHeader, mapData, fileType, 'location')

}
async function getUserDetails(fileType){
  const defaultHeader = ['First Name', 'Last Name', 'Phone', 'Email',
    'Title', 'Address', 'City', 'State/Province', 'Zip',
    'Country', 'Address 2', 'Employee Number', 'Source', 'Role Name', 'Department Name',
  ]
  const { results } = (await axios.get(`user/all-user-for-csv`)).data.data
  generateFile(defaultHeader, results, fileType, 'user')

}


async function getStandardReportDetails(fileType, gridRef, moduleName){
  const columnNameArr = gridRef?.current?.api.getAllColumns()?.map(item => item.colDef.headerName)
  const defaultHeader = ['Group', ...columnNameArr]

  const groupColumn = gridRef?.current?.api?.getRowGroupColumns()
    let name = ''
  if(moduleName === 'asset'){
    name = groupColumn[0].colDef.field.includes('location')?'asset_by_location':
    groupColumn[0].colDef.field.includes('category')?'asset_by_category':
    groupColumn[0].colDef.field.includes('department')?'asset_by_department':
    groupColumn[0].colDef.field.includes('manufacturer')?'asset_by_manufacturer':''
  }else{
    name = 'report_data'
  }
  const { fileData } = (await axios.get(`reports/standard-reports-csv/${moduleName}/${name}`)).data.data

  const results = generateGroupByFileData(fileData, gridRef, moduleName)
  generateFileWhichIncludeGroupByColumn(defaultHeader, results, fileType, `${moduleName}_report`)


}
export default multiFormatFileManager;

